import {useOnboardingTutorialContext} from "../onboardingTutorialContext";
import {OnboardingTutorialButton} from "./OnboardingTutorialButton";
import {useCallback} from "react";

export const OnboardingTutorialStepForwardButton = ({children, disabled, onClick}) => {
    const {handleStepForward} = useOnboardingTutorialContext();
    const handleClick = useCallback(() => {
        handleStepForward();
        if (onClick) {
            onClick()
        }
    }, [handleStepForward, onClick])
    return (
            <OnboardingTutorialButton disabled={disabled} onClick={handleClick}>
                {children}
            </OnboardingTutorialButton>
    )
}